import { combineEpics } from 'redux-observable';

/**
 * You can always add more epics here
 */
//export default combineEpics(searchBarEpic);
export default combineEpics();
